module.exports = __webpack_public_path__ + "static/media/delete_icon.3e89d27d.svg";